export const getEnvVar = (key: string) => {
    try {
        const envVar = import.meta.env[key];

        if (envVar !== undefined) {
            return envVar;
        }
    } catch {
        /* empty */
    }

    try {
        const envVar = process.env[key];

        if (envVar !== undefined) {
            return envVar;
        }
    } catch {
        /* empty */
    }

    return '';
};
